import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  makeStyles,
  Card,
  CardContent,
  CardMedia
} from "@material-ui/core";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Paper
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import * as userActions from "../actions/userActions";
import CustomButton from "../components/common/controls/CustomButton";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import DMModal from "../components/common/controls/DMModal";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import { sortMoelService } from "../services/ModelsService";
import { uuidv4 } from "../utilities/applicationutils";
import "./pageStyles.scss";
import Loading from "../components/Loading/Loading";

import {
  FilterTypeGrid,
  centerDivContainer,
  checkboxLabel,
  filterAccordionSummary,
} from "../styles";
import { getRoles } from "@testing-library/react";

var CONTROLS_DATA = require("./ControlsData.json");
var MODELS_CONTROLS = CONTROLS_DATA.SCREENS.USERS;

const SalesUsers = ({
  modelState,
  getModels,
  deleteModel,
  createNewUser,
  updateUserAction,
  updateModel,
  getRegions,
  onMoreOptionsSelected,
  onTabSelected,
  setSnackBar,
  onPageSelected,
  onCloseSelected,
  getRegionsList,
  getSalesOfficeList,
  getRolesList,
  getUserRegionsList,
  getUserSalesOfficeList,
  getByRegionsUsersList,
  getRenderUsersListData,
  getSelectedRegionsData,
  getSalesOfficeSelectedData,
  userRegionList,
  regionUserList,
  regionsList,
  rolesList,
  userSalesOfficeList,
  salesOfficeList,
  renderUsersListData,
  regionCheckbox,
  salesOfficeCheckbox,
  regionBasedSalesOffice,
  getRegionBasedSalesOffice,
  updateUser,
  getSalesOffice
}) => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [showNewModel, setShowNewModel] = useState(false);
  const [selectedRole, setSelectedRole] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedModel, setSelectedModel] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const onNewProjectClick = () => setShowNewModel(true);
  const [userType, setUserType] = useState("");
  const [userRole, setUserRole] = useState("")
  const [selectedRegion, setSelectedRegion] = useState("")
  const [newModel, setNewModel] = useState();   /// temporary remove it
  const [updateOrAddUser, setUpdateOrAddUser] = useState(false);
  const [editUserId,setEditUserId] = useState("");
  const [regionSelectedId, setRegionSelectedId] = useState(localStorage.getItem("regionIdValue"));
  //const [renderUsersListData, setRenderUsersListData] = useState([]);

  //Below is used call all the apis here
  useEffect(() => {
    const regionLevelId = {regionId: regionSelectedId}
    const fetchAndManipulateApiData = async () => {
      try {
        await Promise.all([
          getRegionsList(),
          getSalesOffice(regionLevelId),
          // getSalesOfficeList(),
          getRolesList(),
          // getUserRegionsList(),
          getByRegionsUsersList(regionLevelId)
          //getUserSalesOfficeList()
        ]);
      }
      catch (error) {
        console.log('throws error while fetchandmanipulateapidata', error);
      }
    }
    fetchAndManipulateApiData();
  }, [getRegionsList, getSalesOffice, getSalesOfficeList, getRolesList, getByRegionsUsersList, getUserSalesOfficeList]);

  

  useEffect(() => {
    if(regionsList.length > 0){
        const updatedSelectedRegion = regionsList.map((item) => {
          return {
            regionId: item.regionId,
            regionName: item.regionName,
            checked: true,
          };
        })
      getSelectedRegionsData(updatedSelectedRegion);
    }

    if(salesOfficeList.length > 0){
        const updatedSelectedSalesOffice = salesOfficeList.map((item) => {
            return {
              currencyId: item.currencyId,
              isCarrier: item.isCarrier,
              isDevelopedEconomy: item.isDevelopedEconomy,
              regionId: item.regionId,
              salesOfficeId: item.salesOfficeId,
              salesOfficeName: item.salesOfficeName,
              checked: true,
            };
          })
      getSalesOfficeSelectedData(updatedSelectedSalesOffice);
    }

  }, [regionsList,salesOfficeList]);

  //Below is used to manipulate the apis data to a userReder data in table
  useEffect(() => {
    if (regionUserList && regionCheckbox && rolesList && userSalesOfficeList && salesOfficeCheckbox) {
        
        const selectedRegionIds = regionCheckbox.map((region) => parseInt(region?.regionId)) || [];
        const selectedSalesOfficeIds = salesOfficeCheckbox.map((office) => parseInt(office?.salesOfficeId)) || [];

        // Filter users based on selected salesOfficeId and regionId
        const filteredUsers = regionUserList.filter((user) => {
          if(selectedSalesOfficeIds.includes(user?.salesOfficeId) && selectedRegionIds?.includes(user?.regionId)){
            return true;
          }
          else if(user?.salesOfficeId === null){
            return true;
          }
          else{
            return false;
          }
        });

        // Merge the filtered data
        const updateUsersListData = filteredUsers.map((user) => {
          const region = regionCheckbox.find((region) => region.regionId == user.regionId);
          const salesOffice = salesOfficeCheckbox.find((office) => office.salesOfficeId == user.salesOfficeId);
          const role = rolesList.find((role) => role.roleId == user.roleId);

          return {
            userName: user.userName,
            regionName: region?.regionName || "N/A",
            salesOfficeName: salesOffice?.salesOfficeName || "N/A",
            roleName: role?.roleText || "N/A",
            userEmail: user.userEmail,
          };
        });

      getRenderUsersListData(updateUsersListData);
    }
    else {
      getRenderUsersListData([]);
    }
  }, [userRegionList, regionCheckbox, rolesList, salesOfficeCheckbox])

  //To handle the onChange event of Region checkbox
  const handleRegionCheckbox = (event, data) => {
    const value = event.target.value;
    if (value === "all") {

      const updateRegionCheckBox =  regionsList.length === regionCheckbox.length
          ? []
          : regionsList.map((item) => {
            return {
              regionId: item.regionId,
              regionName: item.regionName,
              checked: true,
            };
          })
      
      updateRegionCheckBox.length === 0 ? getSalesOfficeSelectedData(updateRegionCheckBox) && getSelectedRegionsData(updateRegionCheckBox) : getSelectedRegionsData(updateRegionCheckBox);
      return;
    }
    const list = [...regionCheckbox];
    const index = list.map((item) => item.regionName).indexOf(data.regionName);
    index === -1 ? list.push(data) : list.splice(index, 1);
    
    getSelectedRegionsData(list);
  };

  //To check whether all checkboxes of Region are checked or not
  const isAllRegionSelected = Array.isArray(regionsList) && Array.isArray(regionCheckbox) &&
  regionsList.length > 0 &&
    regionCheckbox.length > 0 &&
    regionsList.length === regionCheckbox.length;
 
  //To handle the onChange event of SalesOffice checkbox
  const handleSalesOfficeCheckbox = (event, data) => {
    const value = event.target.value;
    if (value === "all") {
      const updateSalesOfficeCheckBox =   salesOfficeList.length === salesOfficeCheckbox.length
          ? []
          : salesOfficeList.map((item) => {
            return {
              currencyId: item.currencyId,
              isCarrier: item.isCarrier,
              isDevelopedEconomy: item.isDevelopedEconomy,
              regionId: item.regionId,
              salesOfficeId: item.salesOfficeId,
              salesOfficeName: item.salesOfficeName,
              checked: true,
            };
          })
      
      getSalesOfficeSelectedData(updateSalesOfficeCheckBox);
      return;
    }
    const list = [...salesOfficeCheckbox];
    const index = list.map((item) => item.salesOfficeName).indexOf(data.salesOfficeName);
    index === -1 ? list.push(data) : list.splice(index, 1);
    
    getSalesOfficeSelectedData(list);
  };

  //To check whether all checkboxes of SalesOffice are checked or not
  const isAllSalesOfficeSelected = Array.isArray(salesOfficeList) && Array.isArray(salesOfficeCheckbox) &&
  salesOfficeList.length > 0 &&
    salesOfficeCheckbox.length > 0 &&
    salesOfficeList.length === salesOfficeCheckbox.length;

  const onSelectedPage = (selectedPage) => {
    onPageSelected(selectedPage);
  };

  const handleNewModelName = (e) => {
    setNewModel({ ...newModel, model: e.target.value });
  };

  const handleRoleNewModel = (e) => {
    const roleTypeVal = e.target.value;
    const userRole = rolesList.find((role) => role.roleId == e.target.value);
    setUserType(userRole.userType);
    setSelectedRole(e.target.value);
  };

  const handleRegionNewModel = (e) => {
    const regionSelectDropDown = e.target.value;
    setNewModel({ ...newModel, region: e.target.value });
    if(regionSelectDropDown){
      const fetchRegionBasedSalesOffice = async() => {
        await getRegionBasedSalesOffice(regionSelectDropDown);
      }
      fetchRegionBasedSalesOffice();
    }
  };

  const handleSalesOfficeNewModel = (e) => {
    setNewModel({ ...newModel, salesOffice: e.target.value });
  };

  const onEdit = (user) => {
    setUserEmail(user.userEmail);
    setUpdateOrAddUser(true);
    setUserName(user.userName);
    const roleIdFind = rolesList.find((role) => role.roleText == user.roleName);
    const userIdFind = userRegionList.find((e) => e.userEmail == user.userEmail);
    setEditUserId(userIdFind.userId);
    setSelectedRole(roleIdFind.roleId);
    setUserType(roleIdFind.userType);
    if(roleIdFind.userType === "ADMIN"){

    }
    else if(roleIdFind.userType === "REGION"){
      const regionIdFind = regionsList.find((region) => region.regionName.toLowerCase() === user.regionName.toLowerCase());
      setNewModel({...newModel,region:regionIdFind.regionId,salesOffice:null})
    }
    else if(roleIdFind.userType === "SALES_OFFICE"){
      const regionIdFind = regionsList.find((region) => region.regionName.toLowerCase() === user.regionName.toLowerCase());
      if(regionIdFind?.regionId){
        const fetchRegionBasedSalesOffice = async() => {
          await getRegionBasedSalesOffice(regionIdFind?.regionId);
        }
        fetchRegionBasedSalesOffice();
      }
      const salesOfficeIdFind = salesOfficeList.find((office) => office.salesOfficeName.toLowerCase() === user.salesOfficeName.toLowerCase());
      setNewModel({...newModel,region:regionIdFind.regionId,salesOffice:salesOfficeIdFind.salesOfficeId})
    }
    setShowNewModel(true);
  };

  const onDelete = (modelId) => {
    setShowDelete(true);
    setSelectedModel(models.filter((m) => m.modelId === modelId)[0]);
  };

  const onUpdateModelName = async (value, model) => {
    const { isSame, isPresent } = isModelPresent(
      value,
      model,
      modelState.models.data
    );
    if (isSame) {
      return;
    }
    if (isPresent) {
      setSnackBar(true, "error", "Model Name already exists");
      setGridData([]);
      setModels([...models]);
    } else {
      try {
        const payload = {
          modelId: model.modelId,
          modelName: value,
          regionId: model.regionId,
          isActive: model.status,
        };
        await updateModel(payload);
        if (!modelState.updateModel.hasError) {
          setSnackBar(true, "success", `Model name updated`);
          await getModels();
          setModels(modelState.models.data);
          setSnackBar(true, "success", `${value} has been updated`);
        }
      } catch (error) {
        setShowNewModel(false);
        setSnackBar(
          true,
          "error",
          `Error while updating model ${model?.model}`
        );
      }
    }
  };


  // render response of each row column of userDetails array object
  useEffect(() => {
    const ctrlData = [];
    renderUsersListData.length > 0 && renderUsersListData.forEach((model) => {
      ctrlData.push({
        rowKey: model.modelId,
        userName: model.userName,
        regionName: model.regionName,
        salesOfficeName: model.salesOfficeName,
        roleName: model.roleName,
        userEmail: model.userEmail,
        rowValue: [
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.userName,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",
              value: model.regionName,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "130px",
              value: model.salesOfficeName,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "170px",
              value: model.roleName,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "170px",
              value: model.userEmail,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          // {
          //   colType: "grid-actions",
          //   colOptions: [
          //     {
          //       name: "edit",
          //       tab: "models",
          //       action: () => onEdit(model),
          //       width: "850px",
          //     },
          //     { name: "delete", action: () => onDelete(model.modelId) },
          //   ],
          // },
        ],
      });
    });
    setGridData(ctrlData);
    
  }, [renderUsersListData]);

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 222,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "20% 20% 15% 20% 20% 5%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isModelPresent = (modelName, selectedModel, data) => {
    let isPresent = false;

    if (modelName === selectedModel.modelName) {
      return { isSame: true, isPresent };
    }

    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.regionId == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }

    return { isSame: false, isPresent };
  };

  const isModelPresentInNew = (userName, userEmail, data) => {
    let isPresent = false;
    for (let user of data) {
      if (
        userName.toLowerCase() == user.userName.toLowerCase() &&
        user.userEmail == userEmail
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const handleCreateModel = async () => {
    const isPresent = isModelPresentInNew(
      userName,
      userEmail,
      renderUsersListData
    );
    setLoading(true);
    if(updateOrAddUser){
      if (isPresent) {
        setLoading(false);
        setSnackBar(true, "error", "User Name and User Email already exists");
      } else {
        try {
          const payload = {
            userId: editUserId,
            userName: userName,
            userEmail: userEmail,
            roleId: selectedRole,
            salesOfficeId:newModel?.salesOffice,
            regionId:newModel?.region
          };
          await updateUserAction(payload);
  
          if (!updateUser.hasError) {
            await Promise.all([
              getRegionsList(),
              getSalesOfficeList(),
              getRolesList(),
              getUserRegionsList(),
              //getUserSalesOfficeList()
            ]);
            setSnackBar(true, "success", `Update User ${userName}`);
            setShowNewModel(false);
            setUserEmail("");
            setUserName("");
            setNewModel({...newModel,region:{}, salesOffice:{}, role:{}});
            setLoading(false);
            setUpdateOrAddUser(false);
          }
        } catch (error) {
          setShowNewModel(false);
          setUpdateOrAddUser(false);
          setUserEmail("");
          setUserName("");
          setNewModel({...newModel,region:{}, salesOffice:{}, role:{}});
          setLoading(false);
          setSnackBar(
            true,
            "error",
            `Error while creating a new model ${userName}`
          );
        }
      }
    }else{
      if (isPresent) {
        setLoading(false);
        setSnackBar(true, "error", "User Name and User Email already exists");
      } else {
        try {
          const payload = {
            userName: userName,
            userEmail: userEmail,
            roleId: selectedRole,
            salesOfficeId:newModel?.salesOffice,
            regionId:newModel?.region
          };
          await createNewUser(payload);
  
          if (!createNewUser.hasError) {
            await Promise.all([
              getRegionsList(),
              getSalesOfficeList(),
              getRolesList(),
              getUserRegionsList(),
              //getUserSalesOfficeList()
            ]);
            setSnackBar(true, "success", `Created new User ${userName}`);
            setShowNewModel(false);
            setUserEmail("");
            setUserName("");
            setNewModel({...newModel,region:{}, salesOffice:{}, role:{}});
            setLoading(false);
          }
        } catch (error) {
          setShowNewModel(false);
          setSnackBar(
            true,
            "error",
            `Error while creating a new model ${newModel?.model}`
          );
        }
      }
    }
  };

  const deleteConfirm = async (selectedModel) => {
    try {
      await deleteModel({ modelId: selectedModel.modelId });
      if (!modelState.deleteModel.hasError) {
        setShowDelete(false);
        await getModels();
        // setModels(modelState.models.data);
        setSnackBar(
          true,
          "success",
          `${selectedModel.modelName} has been deleted.`
        );
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `Error while deleting model ${selectedModel.modelName}`
      );
    }
  };

  const updatePropertyName = (inputArray, oldPropertyName, newPropertyName) => {
    const updatedArray = inputArray?.map((obj) => {
      const { [oldPropertyName]: propertyValue, ...rest } = obj;
      return {
        [newPropertyName]: propertyValue,
        ...rest,
      };
    });
    return updatedArray;
  };


  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={12} md={12} className="page-content">
        <Grid container item xs={3} md={3} className="page-menu left-filter-panel">
          <Card className="filter-pane-scroll" style={{ minWidth: 275 }}>
            <Typography className="filter-label" gutterBottom>
              Filters
            </Typography>
            {/* <Accordion style={FilterTypeGrid}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="status-content"
                id="status-header"
                style={filterAccordionSummary}
              >
                <Typography className="filter-type-label">{("Region")}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0px 36px 0px 0px" }}>
                <Grid>
                  <Grid style={centerDivContainer}>
                    <Checkbox
                      value="all"
                      onChange={(event) => handleRegionCheckbox(event, isAllRegionSelected)}
                      checked={isAllRegionSelected}
                    />
                    <Typography className="filter-type-item">{("SELECT ALL")}</Typography>
                  </Grid>
                  {regionsList && regionsList.map((list, i) => {
                    const checked = regionCheckbox.some((data) => {
                      return list.regionName === data.regionName;
                    });

                    return (
                      <Grid key={i} style={checkboxLabel}>
                        <Checkbox
                          value={list.regionName}
                          onChange={(event) => handleRegionCheckbox(event, list)}
                          checked={checked}
                        />
                        <Grid
                          sx={{
                            position: "relative",
                            top: 10,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Typography className="filter-type-item">{list.regionName}</Typography>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </AccordionDetails>
            </Accordion> */}
            <Accordion style={FilterTypeGrid} defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="sites-content"
                id="sites-header"
                style={filterAccordionSummary}
              >
                <Typography className="filter-type-label">{("Sales Office")}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0px 36px 0px 0px" }}>
                <Grid>
                  <Grid style={centerDivContainer}>
                    <Checkbox
                      value="all"
                      onChange={(event) => handleSalesOfficeCheckbox(event, {})}
                      checked={isAllSalesOfficeSelected}
                    />
                    <Typography className="filter-type-item">{("SELECT ALL")}</Typography>
                  </Grid>
                  {salesOfficeList && salesOfficeList.map((list, i) => {
                    const checked = salesOfficeCheckbox.some((data) => {
                      return list.salesOfficeName === data.salesOfficeName;
                    });

                    return (
                      <Grid key={i} style={checkboxLabel}>
                        <Checkbox
                          value={list.salesOfficeName}
                          onChange={(event) => handleSalesOfficeCheckbox(event, list)}
                          checked={checked}
                        />
                        <Grid
                          sx={{
                            position: "relative",
                            top: 10,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Typography className="filter-type-item">{list.salesOfficeName}</Typography>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Card>
        </Grid>
        <Grid container item xs={9} md={9} className="page-menu">
          {/* <Card style= {{ width: '100%', padding: 10 }}>  */}
          <Grid item container xs={12} md={11} justify="flex-end">
          </Grid>
          {gridData?.length == 0 &&      
          <Grid item container xs={12} md={11}>
            <Typography className="filter-label" gutterBottom sx={{paddingLeft:10}}>No Records Found.</Typography>
          </Grid>
          }
          <Grid item container xs={12} md={11}>
            {gridData?.length > 0 && (
              <DMGrid
                key={gridData?.length || 0}
                headers={MODELS_CONTROLS.GRID_HEADERS}
                headerClassName={classes.gridHeaderColumns}
                data={gridData}
                loading={loading}
                selectedPage={modelState.selectedPage}
                onPageSelection={onSelectedPage}
              />
            )} </Grid>
          {/* </Card> */}
        </Grid>


        <DMModal open={showNewModel} onClose={() => setShowNewModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">New User</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

              <TextField
                id="outlined-basic-userName"
                label="Name*"
                variant="outlined"
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
              <TextField
                id="outlined-basic-userEmail"
                label="Email*"
                variant="outlined"
                type="email"
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
              />
              <TextField
                id=""
                select
                labelId="region-name-select-required-label"
                label={"Role"}
                variant="outlined"
                value={selectedRole}
                onChange={handleRoleNewModel}
                placeholder="Role"
              >
                {rolesList.map((role) => {
                  return (
                    <MenuItem value={role.roleId}>
                      {role.roleText}
                    </MenuItem>
                  );
                })}
              </TextField>
              {userType === "SALES_OFFICE" && 
              <>
              <TextField
                id=""
                select
                labelId="region-name-select-required-label"
                label={"Region"}
                variant="outlined"
                value={newModel?.region}
                onChange={handleRegionNewModel}
                placeholder="Region"
              >
                {regionsList.map((region) => {
                  return (
                    <MenuItem value={region.regionId}>
                      {region.regionName}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                id=""
                select
                labelId="region-name-select-required-label"
                label={"Sales Office"}
                variant="outlined"
                value={newModel?.salesOffice}
                onChange={handleSalesOfficeNewModel}
                placeholder="Sales Office"
              >
                {regionBasedSalesOffice.map((salesOffice) => {
                  return (
                    <MenuItem value={salesOffice.salesOfficeId}>
                      {salesOffice.salesOfficeName}
                    </MenuItem>
                  );
                })}
              </TextField>
              </>
              }
              {userType === "REGION" && 
                <TextField
                  id=""
                  select
                  labelId="region-name-select-required-label"
                  label={"Region"}
                  variant="outlined"
                  value={newModel?.region}
                  onChange={handleRegionNewModel}
                  placeholder="Region"
                >
                  {regionsList.map((region) => {
                    return (
                      <MenuItem value={region.regionId}>
                        {region.regionName}
                      </MenuItem>
                    );
                  })}
                </TextField>
              }
              <Grid
                item
                xs={9}
                container
                style={{ justifyContent: "center" }}
              >
                <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowNewModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCreateModel}
                    //disabled={isDisabled}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMDeleteDialog
          open={showDelete}
          onClose={() => setShowDelete(false)}
          title={"Are you sure to delete?"}
          contentText={`All related Data descriptions, Views and Drawings of ${selectedModel?.modelName} will be deleted.`}
          discardText={"Discard"}
          agreeText={"Agree"}
          onProceed={() => {
            deleteConfirm(selectedModel);
          }}
        />

        {/* Dialog for unsave chabges warning */}
        <DMDeleteDialog
          open={unsaveChangePopup}
          onClose={() => setUnsaveChangePopup(false)}
          title={"Warning"}
          contentText={`You have unsaved changes, On close you will loose all your changes. Are you sure you want to close?`}
          discardText={"Cancel"}
          agreeText={"Yes"}
          onProceed={() => {
            onCloseSelected({
              id: "",
              isClosed: true,
            });
            setUnsaveChangePopup(false);
            setIsUnsaveChanges(false);
          }}
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            setShowMoreOptions(false);
          }}
        >
        </Menu>
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};


const mapStateToProps = (state) => ({
  modelState: state.usersList,
  regionsList: state.usersList.users.regionsList || [],
  salesOfficeList: state.model.tripleScreen.sales || [],
  // salesOfficeList: state.usersList.users.salesOfficeList || [],
  rolesList: state.usersList.users.rolesList || [],
  userRegionList: state.usersList.users.userRegionList || [],
  regionUserList: state.usersList.users.regionUserList || [],
  userSalesOfficeList: state.usersList.users.userSalesOfficeList || [],
  renderUsersListData: state.usersList.renderUsersListData || [],
  regionCheckbox: state.usersList.regionCheckbox || [],
  salesOfficeCheckbox: state.usersList.salesOfficeCheckbox || [],
  regionBasedSalesOffice: state.usersList.users.regionBasedSalesOffice || [],
  createNewUser : state.usersList.createNewUser,
  updateUser: state.usersList.updateUser
});

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesOffice: async(region) => dispatch(modelAction.getSalesOffice(region)),
    getRegionsList: async () => dispatch(userActions.getRegionsList()),
    getSalesOfficeList: async () => dispatch(userActions.getSalesOfficeList()),
    getRolesList: async () => dispatch(userActions.getRolesList()),
    getUserRegionsList: async () => dispatch(userActions.getUserRegionsList()),
    getByRegionsUsersList: async(regionLevelId) => dispatch(userActions.getByRegionsUsersList(regionLevelId)),
    getUserSalesOfficeList: async () => dispatch(userActions.getUserSalesOfficeList()),
    getModels: async () => dispatch(modelAction.getModels()),
    deleteModel: async (requestPayload) =>
      dispatch(modelAction.deleteModel(requestPayload)),
    createNewUser: async (requestPayload) =>
      dispatch(userActions.createNewUser(requestPayload)),
    updateModel: async (requestPayload) =>
      dispatch(modelAction.updateModel(requestPayload)),
    getRegions: async () => dispatch(modelAction.getRegions()),
    onMoreOptionsSelected: (modelId) =>
      dispatch(miscAction.onModelSelected(modelId)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
    getSelectedRegionsData: (regionCheckbox) => dispatch(userActions.getSelectedRegionsData(regionCheckbox)),
    getSalesOfficeSelectedData: (salesOfficeCheckbox) => dispatch(userActions.getSalesOfficeSelectedData(salesOfficeCheckbox)),
    getRenderUsersListData: (renderUsersListData) => dispatch(userActions.getRenderUsersListData(renderUsersListData)),
    getRegionBasedSalesOffice: (regionId) => dispatch(userActions.getRegionBasedSalesOffice(regionId)),
    updateUserAction: (requestPayload) => dispatch(userActions.updateUserAction(requestPayload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesUsers);
